<template>
  <div>
    <p>
      <span class="txt">设备名称</span>
      <el-input
        v-model="equipment_name"
        clearable
        size="small"
        placeholder="请输入内容"
        style="width:180px;margin-right:20px;" />

      <el-button size="mini" type="primary" icon="el-icon-search" @click="searchBtn"> 搜索 </el-button>
      <el-button size="mini" type="success" icon="el-icon-plus" @click="addBtn"> 新增 </el-button>
    </p>
    <el-table
      ref="multipleTable"
      :data="tableData"
      :header-cell-style="{background:'#41A1FF',color:'#fff'}"
      border
      tooltip-effect="dark"
      style="width: 100%"
      size="small">

      <el-table-column align="center" label="设备图片">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.img_url[0]"
            :preview-src-list="scope.row.img_url"
            style="width: 50px; height: 50px"/>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="equipment_name" label="设备名称" />

      <el-table-column align="center" prop="name" label="创建人" />
      <el-table-column align="center" prop="describe" label="设备描述" />

      <el-table-column align="center" fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="editBtn(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 10px;text-align: center;">
      <el-pagination
        :current-page="page"
        :page-sizes="[8, 15, 30, 50]"
        :page-size="page_size"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"/>
    </div>

    <el-dialog :visible.sync="dialogFormVisible" title="新增设备">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item :label-width="formLabelWidth" label="上传图片">
          <el-upload
            :file-list="addFileList"
            :headers="{Authorization:token}"
            :data="{'upload_type':'image'}"
            :on-preview="handlePictureCardPreview"
            :on-success="uploadSuccess"
            :on-remove="addHandleRemove"
            :action="action"
            list-type="picture-card"
            name="files"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF">
            <i class="el-icon-plus"/>
          </el-upload>
          <el-dialog :visible.sync="dialogVisibleImg" append-to-body>
            <img :src="dialogImageUrl" width="100%" alt="">
          </el-dialog>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="设备名称" prop="equipment_name">
          <el-input v-model="form.equipment_name" autocomplete="off" />
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="设备描述" prop="describe">
          <el-input :autosize="{ minRows: 2}" v-model="form.describe" type="textarea" autocomplete="off" />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addSubmit('form')">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="editFormVisible" title="编辑设备">
      <el-form ref="editform" :model="editform" :rules="rules">
        <el-form-item :label-width="formLabelWidth" label="图片">
          <el-upload
            :headers="{Authorization:token}"
            :file-list="editFileList"
            :on-success="uploadSuccess2"
            :on-remove="editHandleRemove"
            :data="{'upload_type':'image'}"
            :on-preview="handlePictureCardPreview"
            :action="action"
            list-type="picture-card"
            name="files"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF">
            <i class="el-icon-plus"/>
          </el-upload>
          <el-dialog :visible.sync="dialogVisibleImg" append-to-body>
            <img :src="dialogImageUrl" width="100%" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="设备名称" prop="equipment_name">
          <el-input v-model="editform.equipment_name" autocomplete="off" />
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="设备描述" prop="describe">
          <el-input :autosize="{ minRows: 2}" v-model="editform.describe" type="textarea" autocomplete="off" />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editSubmit('editform')">提 交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// import { getUserInfoByIdList } from '@/api/login'
import { searchEquipment, addEquipment, editEquipment } from '@/api/equipment'

export default {
  data() {
    return {
      total: 0,
      page: 1,
      page_size: 8,
      equipment_name: '',
      tableData: [],
      token: this.$store.getters.token,
      form: {
        equipment_name: '',
        img_url: [],
        describe: ''
      },
      editform: {
        equipment_name: '',
        img_url: [],
        describe: '',
        id: ''
      },
      dialogFormVisible: false,
      editFormVisible: false,
      dialogVisibleImg: false,
      dialogImageUrl: '',
      addFileList: [], // tianjia文件时的文件列表
      editFileList: [], // 编辑文件时的文件列表
      rules: {
        describe: [
          { required: false, message: '请输入描述', trigger: 'blur' }
        ],
        equipment_name: [
          { required: true, message: '请输入设备名', trigger: 'blur' }
        ]
      },
      multipleSelection: [],
      formLabelWidth: '120px',
      srcList: [],
      action: process.env.VUE_APP_BASE_API + '/common/upload'
    }
  },
  created() {
    this.searchBtn()
  },
  methods: {
    searchBtn() {
      const data = {
        equipment_name: this.equipment_name,
        page: 1,
        page_size: this.page_size
      }
      this.getList(data)
    },
    getList(params) {
      searchEquipment(params).then(response3 => {
        if (response3.code === 'success') {
          const responseData = response3.data.equipment.equipments
          this.tableData = responseData
          this.total = response3.data.equipment.pagination.total
        } else {
          this.tableData = []
          this.total = 0
          this.errMsg()
        }
      }).catch()
    },
    addBtn() {
      this.srcList = []// 其实没什么用这个  添加成功删除成功 给添加表单 图片列表 赋值
      this.addFileList = []// 清空文件上传列表
      this.form.img_url = []// 清空参数图片列表
      this.dialogFormVisible = true
    },
    addSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 少了img_url
          const form = {}
          form.equipment_name = this.form.equipment_name
          form.describe = this.form.describe
          form.img_url = this.form.img_url
          addEquipment(form).then(response1 => {
            if (response1.code === 'success') {
              this.successMsg()
              this.form = {
                equipment_name: '',
                img_url: [],
                describe: ''
              }
              this.dialogFormVisible = false

              this.searchBtn()
            } else {
              this.errMsg()
            }
          }).catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 少了img_url
          const form = {}
          form.equipment_name = this.editform.equipment_name
          form.describe = this.editform.describe

          form.id = this.editform.id

          form.img_url = []
          for (const item of this.editFileList) {
            form.img_url = form.img_url.concat(item.response.data.urls)
          }

          editEquipment(form).then(response1 => {
            if (response1.code === 'success') {
              this.successMsg()
              this.editform = {
                equipment_name: '',
                img_url: [],
                describe: '',
                id: ''
              }
              this.editFormVisible = false
              this.searchBtn()
            } else {
              this.errMsg()
            }
          }).catch(() => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    successMsg() {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    errMsg() {
      this.$message({
        message: '操作失败',
        type: 'error'
      })
    },

    // 图片
    addHandleRemove(file, fileList) {
      // const url = file.response.data.urls
      const urlList = []

      for (var i = 0; i < fileList.length; i++) {
        urlList.push(fileList[i].response.data.urls[0])
      }
      this.form.img_url = urlList
      this.srcList = urlList
    },
    editHandleRemove(file, fileList) {
      this.editFileList = fileList
    },
    uploadSuccess(response) {
      this.srcList = this.srcList.concat(response.data.urls)
      this.form.img_url = this.srcList
    },
    uploadSuccess2(response, file, fileList) {
      this.editFileList = fileList
    },
    handlePictureCardPreview(file) { // 看图
      this.dialogImageUrl = file.url
      this.dialogVisibleImg = true
    },

    // 编辑
    editBtn(row) {
      this.editFormVisible = true
      this.editform.equipment_name = row.equipment_name
      this.editform.describe = row.describe
      this.editform.img_url = row.img_url
      this.editform.id = row.id
      this.editFileList = []
      if (row.img_url) {
        // 因为上传成功返回的数据结构和 自定义的绑定的文件列表结构有区别,和后期取值不便所以设置结构一样
        for (const item of row.img_url) {
          const name = { response: { data: { urls: [item] }}, url: item }

          this.editFileList.push(name)
        }
      }
    },
    // 翻页
    handleSizeChange(val) {
      this.page_size = val
      const data = {
        equipment_name: this.equipment_name,
        page: 1,
        page_size: val
      }
      this.getList(data)
    },
    handleCurrentChange(val) {
      this.page = val
      const data = {
        equipment_name: this.equipment_name,
        page: val,
        page_size: this.page_size
      }
      this.getList(data)
    }
  }
}
</script>
<style scope>
.txt {
  text-align: right;
  vertical-align: middle;
  font-weight: 700;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
